import { Link } from "react-router-dom";
import { Carrot, ArrowLeft } from "lucide-react";

export const LegalLayout = ({ title, updated, children }) => (
  <div className="min-h-screen bg-background grain">
    <header className="max-w-3xl mx-auto px-6 h-16 flex items-center justify-between">
      <Link to="/" className="flex items-center gap-2" data-testid="legal-logo-home">
        <div className="w-9 h-9 rounded-xl bg-primary flex items-center justify-center">
          <Carrot className="w-5 h-5 text-white" />
        </div>
        <span className="text-xl font-extrabold tracking-tight">Carrot</span>
      </Link>
      <Link to="/" className="inline-flex items-center gap-1.5 text-sm font-semibold text-muted-foreground hover:text-foreground" data-testid="legal-back-home">
        <ArrowLeft className="w-4 h-4" /> Back
      </Link>
    </header>

    <main className="max-w-3xl mx-auto px-6 py-10">
      <h1 className="text-3xl sm:text-4xl font-black tracking-tight">{title}</h1>
      <p className="mt-2 text-sm text-muted-foreground">Last updated: {updated}</p>
      <div className="mt-8 space-y-6 text-[15px] leading-relaxed text-foreground/90">{children}</div>
      <p className="mt-12 text-sm text-muted-foreground">
        Questions? Contact us at{" "}
        <a href="mailto:hxcdelivery@gmail.com" className="font-semibold text-primary hover:underline">hxcdelivery@gmail.com</a>.
      </p>
    </main>
  </div>
);

export const Section = ({ heading, children }) => (
  <section className="space-y-2">
    <h2 className="text-lg font-bold text-foreground">{heading}</h2>
    {children}
  </section>
);
